import { equalSymbolCheckReg } from './constants';
import { evaluate } from './math/math';

export function evaluateFormula(value: string, scope: Record<string, unknown>) {
  const normalizedValue = value.replace(equalSymbolCheckReg, (match) => {
    return match[0] + '==';
  });

  try {
    return evaluate(normalizedValue, scope);
  } catch (e: any) {
    throw new Error(e.message);
  }
}
